
import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber} from "../utilities/NumberFormatter";

export function InventoryPrint(body, name, itemName, dateRange) {
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });

    const bList = body.map(element => [
        element.date,
        element.invoiceId,
        element.mode,
        element.customerName, // Removed printFormatNumber if it's text, keep if it's numeric
        printFormatNumber(element.sold),
        printFormatNumber(element.purchase),
        printFormatNumber(element.balance),
        element.location,
        element.comment
    ]);

    const heading = ['Date', 'Folio', 'Mode', 'Customer', 'Sale', 'Purchase', 'Balance', 'Loc', 'Comment'];

    // Header Section
    doc.setFontSize(16);
    doc.setTextColor(40);
    doc.text("Inventory Report", 220, 30, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(name, 20, 45);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Item: ${itemName}`, 20, 58);
    doc.text(`Date Range: ${dateRange}`, 300, 58);

    autoTable(doc, {
        head: [heading],
        body: bList,
        startY: 65,
        theme: 'striped', // Enables striped rows
        headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontSize: 8,
            fontStyle: 'bold'
        },
        bodyStyles: {
            fontSize: 7,
            cellPadding: 3
        },
        alternateRowStyles: {
            fillColor: [245, 245, 245]
        },
        columnStyles: {
            0: { halign: "left", cellWidth: 45 },
            1: { halign: "left", cellWidth: 35 },
            2: { halign: "left", cellWidth: 40 },
            3: { halign: "left" },
            4: { halign: "right" },
            5: { halign: "right" },
            6: { halign: "right" },
            7: { halign: "left", cellWidth: 35 },
            8: { halign: "left" },
        },
        margin: { top: 20, left: 20, right: 20 },
    });

    doc.save(`Inventory-${itemName}-${ToBritishDate(new Date())}.pdf`);
}